import { ReactComponent as AreaChartIcon } from '../../assets/icons/chart/chart-icon-area.svg';
import { ReactComponent as AreaChartColoredIcon } from '../../assets/icons/chart/chart-icon-area-colored.svg';
import { ReactComponent as BarChartIcon } from '../../assets/icons/chart/chart-icon-vertical-bar.svg';
import { ReactComponent as BarChartColoredIcon } from '../../assets/icons/chart/chart-icon-vertical-bar-colored.svg';
import { ReactComponent as HorizontalBarChartIcon } from '../../assets/icons/chart/chart-icon-horizontal-bar.svg';
import { ReactComponent as HorizontalBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-horizontal-bar-colored.svg';
import { ReactComponent as TableChartIcon } from '../../assets/icons/chart/chart-icon-table.svg';
import { ReactComponent as TableChartColoredIcon } from '../../assets/icons/chart/chart-icon-table-colored.svg';
import { ReactComponent as LineChartIcon } from '../../assets/icons/chart/chart-icon-line.svg';
import { ReactComponent as LineChartColoredIcon } from '../../assets/icons/chart/chart-icon-line-colored.svg';
import { ReactComponent as PieChartIcon } from '../../assets/icons/chart/chart-icon-pie.svg';
import { ReactComponent as PieChartColoredIcon } from '../../assets/icons/chart/chart-icon-pie-colored.svg';
import { ReactComponent as DonutChartIcon } from '../../assets/icons/chart/chart-icon-donut.svg';
import { ReactComponent as DonutChartColoredIcon } from '../../assets/icons/chart/chart-icon-donut-colored.svg';
import { ReactComponent as NumberChartIcon } from '../../assets/icons/chart/chart-icon-number.svg';
import { ReactComponent as NumberChartColoredIcon } from '../../assets/icons/chart/chart-icon-number-colored.svg';
import { ReactComponent as PivotTableChartIcon } from '../../assets/icons/chart/chart-icon-pivot-table.svg';
import { ReactComponent as PivotTableChartColoredIcon } from '../../assets/icons/chart/chart-icon-pivot-table-colored.svg';
import { ReactComponent as ScatterChartIcon } from '../../assets/icons/chart/chart-icon-scatter.svg';
import { ReactComponent as ScatterChartColoredIcon } from '../../assets/icons/chart/chart-icon-scatter-colored.svg';
import { ReactComponent as HistogramChartIcon } from '../../assets/icons/chart/chart-icon-histogram.svg';
import { ReactComponent as HistogramChartColoredIcon } from '../../assets/icons/chart/chart-icon-histogram-colored.svg';
import { ReactComponent as TreemapChartIcon } from '../../assets/icons/chart/chart-icon-treemap.svg';
import { ReactComponent as TreemapChartColoredIcon } from '../../assets/icons/chart/chart-icon-treemap-colored.svg';
import { ReactComponent as HeatmapChartIcon } from '../../assets/icons/chart/chart-icon-heatmap.svg';
import { ReactComponent as HeatmapChartColoredIcon } from '../../assets/icons/chart/chart-icon-heatmap-colored.svg';
import { ReactComponent as VerticalStackedBarChartIcon } from '../../assets/icons/chart/chart-icon-vertical-stacked-bar.svg';
import { ReactComponent as VerticalStackedBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-vertical-stacked-bar-colored.svg';
import { ReactComponent as HorizontalStackedBarChartIcon } from '../../assets/icons/chart/chart-icon-horizontal-stacked-bar.svg';
import { ReactComponent as HorizontalStackedBarChartColoredIcon } from '../../assets/icons/chart/chart-icon-horizontal-stacked-bar-colored.svg';
import { ReactComponent as ClusteredBarComboChartIcon } from '../../assets/icons/chart/chart-icon-clustered-bar-combo.svg';
import { ReactComponent as ClusteredBarComboChartColoredIcon } from '../../assets/icons/chart/chart-icon-clustered-bar-combo-colored.svg';
import { ReactComponent as StackedBarComboChartIcon } from '../../assets/icons/chart/chart-icon-stacked-bar-combo-chart.svg';
import { ReactComponent as StackedBarComboChartColoredIcon } from '../../assets/icons/chart/chart-icon-stacked-bar-combo-chart-colored.svg';
import { ReactComponent as FunnelChartIcon } from '../../assets/icons/chart/chart-icon-funnel.svg';
import { ReactComponent as FunnelChartColoredIcon } from '../../assets/icons/chart/chart-icon-funnel-colored.svg';
import { ReactComponent as GaugeChartIcon} from '../../assets/icons/chart/gauge-chart.svg'
import { ReactComponent as GaugeChartColoredIcon} from '../../assets/icons/chart/gauge-chart-colored.svg'

// ----------------------------------------------------------------------
//const getIcon = (name, selected) => <Icon className={`blk_icon ${selected ? "cm_select_graph" : ""}`} icon={name} width={35} height={35} />;
//const getCustomIcon = (name, selected) => <span className={`blk_icon ${selected ? "cm_select_graph" : ""}`}>{name}</span>;
const getChartIcon = (icon, iconSelected, selected) => {
    return <span className={`blk_icon`}>{selected ? iconSelected : icon}</span>
};

//#region operator
// minOr : minDimension OR minMeasure
// minAnd_maxAnd : minDimension AND minMeasure    AND   maxDimension AND maxMeasure
//#endregion

const GraphTypesConfig = [
    {
        label: 'Table',
        value: 'table',
        actualValue:'table',
        icon: ({ selected }) => getChartIcon(<TableChartIcon />, <TableChartColoredIcon />, selected),
        requireField: {
            label: "Min 1 dimension in Rows, Min 1 dimension in Columns or 1 measure in Values",
            minDimension: 1,
            minMeasure: 1,
            operator: "minOr"
        }
    },
    {
        label: 'Bar',
        value: 'bar',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<BarChartIcon />, <BarChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            // minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            // operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Horizontal Bar',
        value: 'horizontalBar',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<HorizontalBarChartIcon />, <HorizontalBarChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Line',
        value: 'line',
        actualValue:'line',
        icon: ({ selected }) => getChartIcon(<LineChartIcon />, <LineChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Area',
        value: 'area',
        actualValue:'area',
        icon: ({ selected }) => getChartIcon(<AreaChartIcon />, <AreaChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            // minMeasure: 1,
            maxDimension: 1,
            // maxMeasure: 1,
            // operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Pie',
        value: 'pie',
        actualValue:'pie',
        icon: ({ selected }) => getChartIcon(<PieChartIcon />, <PieChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Donut',
        value: 'donut',
        actualValue:'pie',
        icon: ({ selected }) => getChartIcon(<DonutChartIcon />, <DonutChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Number',
        value: 'number',
        actualValue:'number',
        icon: ({ selected }) => getChartIcon(<NumberChartIcon />, <NumberChartColoredIcon />, selected),
        requireField: {
            label: "1 measure in Value",
            minMeasure: 1
        }
    },
    // number chart will have templates to select from.
    // {
    //     label: 'Number Graphic Card',
    //     value: 'numberGraphicCard',
    //     icon: ({ selected }) => getChartIcon(<NumberChartIcon />, <NumberChartColoredIcon />, selected),
    //     requireField: {
    //         label: "1 Dimension And 1 Measure",
    //         minDimension: 1,
    //         minMeasure: 1,
    //         // maxDimension: 1,
    //         // maxMeasure: 1,
    //         operator: "minOr",
    //     }
    // },
    {
        label: 'Pivot Table',
        value: 'pivotTable',
        actualValue:'table',
        icon: ({ selected }) => getChartIcon(<PivotTableChartIcon />, <PivotTableChartColoredIcon />, selected),
        requireField: {
            label: "Min 1 dimension in Rows, Min 1 dimension in Columns or 1 measure in Values",
            minDimension: 1,
            minMeasure: 1,
            operator: "minOr"
        }
    },
    {
        label: 'Scatter',
        value: 'scatter',
        actualValue:'line',
        icon: ({ selected }) => getChartIcon(<ScatterChartIcon />, <ScatterChartColoredIcon />, selected),
        requireField: {
            label: "Min and Max 2 dimensions of number type, one in x axis and one in values",
            minDimension: 1,
            minMeasure: 0,
            maxDimension: 2,
            maxMeasure: 1,
            // operator: "minOr",
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Histogram',
        value: 'histogram',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<HistogramChartIcon />, <HistogramChartColoredIcon />, selected),
        requireField: {
            label: "One dimension of number type",
            minDimension: 1,
            minMeasure: 0,
            maxDimension: 1,
            maxMeasure: 0,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Treemap',
        value: 'treemap',
        actualValue:'line',
        icon: ({ selected }) => getChartIcon(<TreemapChartIcon />, <TreemapChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Heatmap',
        value: 'heatmap',
        actualValue:'area',
        icon: ({ selected }) => getChartIcon(<HeatmapChartIcon />, <HeatmapChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension in Rows or 1 dimension in Columns and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Vertical stacked 100 % bar chart',
        value: 'verticalStackedBarChart100',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<VerticalStackedBarChartIcon />, <VerticalStackedBarChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Horizontal stacked 100 % bar chart',
        value: 'horizontalStackedBarChart100',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<HorizontalStackedBarChartIcon />, <HorizontalStackedBarChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Clustered bar combo chart',
        value: 'clusteredBarCombo',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<ClusteredBarComboChartIcon />, <ClusteredBarComboChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and min 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2
        }
    },
    {
        label: 'Stacked bar combo chart',
        value: 'stackedBarCombo',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<StackedBarComboChartIcon />, <StackedBarComboChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and min 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2
        }
    },
    {
        label: 'Funnel',
        value: 'funnel',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<FunnelChartIcon />, <FunnelChartColoredIcon />, selected),
        requireField: {
            label: "1 dimension and 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 1,
            maxMeasure: 1,
            operator: "minAnd_maxAnd"
        }
    },
    {
        label: 'Multi Axis Bar Combo',
        value: 'multiAxisBarCombo',
        actualValue:'bar',
        icon: ({ selected }) => getChartIcon(<ClusteredBarComboChartIcon />, <ClusteredBarComboChartColoredIcon />, selected),
        requireField: {
            label: "min 1 dimension, max 2 dimension and min 1 measure",
            minDimension: 1,
            minMeasure: 1,
            maxDimension: 2
        }
    },
    {
        label: 'Gauge Chart',
        value: 'gauge',
        actualValue:'pie',
        icon: ({ selected }) => getChartIcon(<GaugeChartIcon/>, <GaugeChartColoredIcon />, selected),
        requireField: {
            label: "2 measures",
            minMeasure: 1,
            maxMeasure: 2,
        }
    },
];

export default GraphTypesConfig;

export const NumberGraphTemplates = [
    {
        label: 'template 1',
        value: 'template1',
        config: {
            color: false,
            icon: false,
            background: false,
        }
    },
    {
        label: 'template 2',
        value: 'template2',
        config: {
            color: true,
            icon: true,
            background: false,
        }
    },
    {
        label: 'template 3',
        value: 'template3',
        config: {
            color: true,
            icon: true,
            background: true,
        }
    },
    {
        label: 'template 4',
        value: 'template4',
        config: {
            color: true,
            // icon: true,
            // background: true,
        }
    },
    {
        label: 'template 5',
        value: 'template5',
        config: {
            // color: true,
            icon: true,
            // background: true,
            title: true,
            description: true,
        }
    },
]


// text format,